import { type ReactNode } from 'react';
import { BrandHeader } from './BrandHeader';
import { SubscaleSidebar } from './SubscaleSidebar';
import { AppFooter } from './AppFooter';
import { UserBadge } from '@/components/auth/UserBadge';

export function AppShell({
  instrumentId,
  showSidebar = true,
  children,
}: {
  instrumentId: string;
  showSidebar?: boolean;
  children: ReactNode;
}) {
  return (
    <div className="flex h-full flex-col">
      <BrandHeader title="Family Child Care Environment Rating Scale Observation Form">
        <UserBadge role="Observer" />
      </BrandHeader>
      <div className="flex min-h-0 flex-1">
        {showSidebar && <SubscaleSidebar instrumentId={instrumentId} />}
        {/*
         * `overflow-y-auto` makes long routes (MetadataStep form, ItemView
         * 4-column grid, SummaryView score panels) scroll inside `<main>`
         * instead of bleeding out behind the footer. Combined with the
         * parent's `min-h-0`, this keeps header + footer pinned and only
         * the content area scrolls.
         */}
        <main className="flex min-h-0 flex-1 flex-col overflow-y-auto bg-muted/30">
          {children}
        </main>
      </div>
      <AppFooter />
    </div>
  );
}
